import React, { useState, useEffect } from 'react'
import axios from 'axios'

import Btn from '../ui/Btn'
import { Notice, Confirm, Field, IconTrash } from './media'
import './media.css'

/*
 * SPONSOR — one language.
 *
 * Requests untouched:
 *   GET  admin/sponsors/challengelang/{id}/{LangID}
 *   POST admin/sponsors/challengelang        { ...record, LangID, ChallengID }
 *   GET  admin/sponsors/challengelangdel/{UUID}
 *
 * The payload still carries the same (server-spelled) ChallengID key.
 * alert() became an inline notice; window.confirm became an inline confirm.
 */

const EMPTY = { id: 0, Title: '', Descr: '' }

export default function SponsorLangForm(props) {
  const [record, setRecord] = useState(EMPTY)
  const [isLoading, setIsLoading] = useState(false)
  const [note, setNote] = useState(null)
  const [confirmDel, setConfirmDel] = useState(false)
  const [saving, setSaving] = useState(false)

  /* A language with no row yet answers with nothing at all — reading .Title off
     that took the whole form down. Render-side guard only. */
  const rec = record || EMPTY

  useEffect(() => {
    loadData()
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  const save = (e) => {
    e.preventDefault()
    const obj = { ...record, LangID: props.LangID, ChallengID: props.id }
    setSaving(true)
    setNote(null)
    axios.post(process.env.REACT_APP_API_SERVER + 'admin/sponsors/challengelang', obj, {
      headers: {
        'Authorization': 'Bearer ' + sessionStorage.getItem("apiToken")
      }
    })
      .then(res => {
        setSaving(false)
        setNote({ kind: 'good', text: res.data.msg || 'Η αποθήκευση ολοκληρώθηκε.' })
        loadData()
      }).catch(err => {
        setSaving(false)
        setNote({ kind: 'crit', text: 'Υπήρξε ένα πρόβλημα, παρακαλώ προσπαθήστε ξανά' })
      })
  }

  const loadData = () => {
    setIsLoading(true)
    axios.get(process.env.REACT_APP_API_SERVER + 'admin/sponsors/challengelang/' + props.id + '/' + props.LangID, {
      headers: {
        'Authorization': 'Bearer ' + sessionStorage.getItem("apiToken")
      }
    })
      .then(res => {

        setRecord(res.data.results)

        setIsLoading(false)

      }).catch(err => {
        setIsLoading(false)

      })
  }

  const del = () => {
    setConfirmDel(false)
    axios.get(process.env.REACT_APP_API_SERVER + 'admin/sponsors/challengelangdel/' + rec.UUID, {
      headers: {
        'Authorization': 'Bearer ' + sessionStorage.getItem("apiToken")
      }
    })
      .then(res => {
        loadData()
        setNote({ kind: 'good', text: res.data.msg || 'Η διαγραφή ολοκληρώθηκε.' })


      }).catch(err => {
        setIsLoading(false)
        setNote({ kind: 'crit', text: 'Υπήρξε ένα πρόβλημα, παρακαλώ προσπαθήστε ξανά' })
      })
  }

  const fieldId = 'splang-' + props.LangID

  return (
    <form className="md-form" onSubmit={save}>
      {note ? <Notice kind={note.kind} onClose={() => setNote(null)}>{note.text}</Notice> : null}

      <div className="md-group md-group-1">
        <Field label="Τίτλος Sponsor" htmlFor={fieldId + '-title'} required>
          <input
            id={fieldId + '-title'}
            className="md-input"
            type="text"
            required
            value={rec.Title == null ? '' : rec.Title}
            onChange={(e) => setRecord({ ...rec, Title: e.target.value })}
          />
        </Field>

        <Field label="Περιγραφή" htmlFor={fieldId + '-descr'}>
          <textarea
            id={fieldId + '-descr'}
            className="md-textarea"
            rows={3}
            value={rec.Descr == null ? '' : rec.Descr}
            onChange={(e) => setRecord({ ...rec, Descr: e.target.value })}
          />
        </Field>
      </div>

      {confirmDel ? (
        <Confirm
          text={<b>ΔΙΑΓΡΑΦΗ, ΣΙΓΟΥΡΑ?</b>}
          confirmLabel="Διαγραφή"
          cancelLabel="Άκυρο"
          onConfirm={del}
          onCancel={() => setConfirmDel(false)}
        />
      ) : null}

      <div className="md-actions md-actions-split">
        {rec.id != 0 ? (
          <Btn className="md-danger md-actions-left" onClick={() => setConfirmDel(true)}>
            {IconTrash}
            Διαγραφή
          </Btn>
        ) : <span className="md-actions-left" />}

        <Btn variant="accent" type="submit" disabled={saving || isLoading}>
          {saving ? 'Αποθήκευση...' : 'Αποθήκευση'}
        </Btn>
      </div>
    </form>
  )
}
